const initialState = {
    message: {}
};
export default initialState;